// src/pages/static/about/About.jsx  (ή wherever το έχεις)
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextBlock from "../../../components/general/staticPages/aboutUs/textBlock";
import ImageBlock from "../../../components/general/staticPages/aboutUs/imageBlock";
import BannerBox from "../../../components/home/bannerBox";

import coffeeMachine from "../../../assets/aboutUs/coffeeMachine.jpg";
import barista from "../../../assets/aboutUs/barista.jpg";

const About = () => {
    const bodyLeft = `
  <p>
    Η εταιρεία «Brew Specialists» αποτελεί μία άμεση και γρήγορη online λύση
    για τους επαγγελματίες που θέλουν να οργανώσουν ή να ενισχύσουν τον
    επαγγελματικό τους εξοπλισμό.
  </p>

  <p>
    Μέσα από μια ισχυρή ομάδα ανθρώπων με εξειδίκευση και χρόνια εμπειρία στον τομέα,
    η εταιρεία μας παρέχει προϊόντα, υπηρεσίες εκπαίδευσης και διαχείρισης
    εξοπλισμού καθώς και υπηρεσίες service.
  </p>

  <p>
    Μικρές και μεγάλες επιχειρήσεις, τόσο σε Ελλάδα όσο και Κύπρο,
    έχουν τη δυνατότητα να προμηθευτούν χρηστικό καφέ, τσάι και
    επαγγελματικό εξοπλισμό με την υπογραφή των μεγαλύτερων εταιρειών στον τομέα.
  </p>
`;

    const bodyRight = `
  <p>
    Έχοντας στο ενεργητικό μας συνεργασίες με τα πιο ισχυρά brands όπως
    HARIO, ACAIA, ASOBU, AEROPRESS, CHEMEX, TOP MOKA, CAFFETO, KAFFEEFORM,
    LIFEGREEN, ECOFFEE CUP, MELITTA, PALLO, TODDY, MARCO,
    παρέχουμε μια ευρεία γκάμα προϊόντων με κύριο γνώμονα την ποιότητα και
    την καλύτερη δυνατή ανταπόκριση στις ανάγκες των πελατών μας.
  </p>

  <p>
    Επενδύοντας συνεχώς σε νέα προϊόντα και καινοτομίες,
    δημιουργούμε σχέσεις εμπιστοσύνης προσφέροντάς σας
    ολοκληρωμένες λύσεις με επαγγελματισμό και υπευθυνότητα.
  </p>

  <p>
    Βρισκόμαστε πάντα στη διάθεσή σας.<br />
    Η ομάδα της <strong>Brew Specialists</strong>.
  </p>

  <p>
    Για περισσότερες πληροφορίες, παρακαλούμε απευθυνθείτε στο email:
    <a
      href="mailto:sales@brewspecialists.gr"
      style="color:#E5007E; font-weight:700; text-decoration:underline;"
    >
      sales@brewspecialists.gr
    </a>
  </p>
`;


  return (
    <Box sx={{ py: 1, display: "flex", flexDirection: "column", gap: 4,px:2,
        //backgroundColor:"#E9E9E9"
    }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextBlock
            title="THIS IS A TITLE FOR THE COMPANY PAGE"
            body={bodyLeft}
            variant="panel"
            isAbout={true}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ImageBlock src={coffeeMachine} alt="coffeeMachine" />
        </Grid>
        <Grid item xs={12} md={6}>
          <ImageBlock src={barista} alt="barista" />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextBlock body={bodyRight} variant="panel" isAbout={true} />
        </Grid>
      </Grid>
      {/*<Box*/}
      {/*  sx={{*/}
      {/*    display: "flex",*/}
      {/*    flexDirection: { xs: "column", md: "row" },*/}
      {/*    gap: 3,*/}
      {/*    width: "100%",*/}
      {/*    justifyContent: "center",*/}
      {/*    alignItems: "stretch",*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <BannerBox*/}
      {/*    preTitle="ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ"*/}
      {/*    title="SERVICE TITLE"*/}
      {/*    description="Tortor vel facilisis condimentum donec lacus sed ac. Massa mattis phasellus egestas sed nisi ornare viverra netus."*/}
      {/*    image={barista}*/}
      {/*    height={{ xs: "260px", md: "245px" }}*/}
      {/*    width={{ xs: "100%", md: "50%" }}*/}
      {/*    onClick={() => console.log("Banner 1 clicked")}*/}
      {/*  />*/}

      {/*  <BannerBox*/}
      {/*    preTitle="ΣΧΕΤΙΚΑ ΜΕ ΕΜΑΣ"*/}
      {/*    title="SERVICE TITLE TWO"*/}
      {/*    description="Curabitur faucibus, risus vitae bibendum scelerisque, lorem arcu cursus mauris, et fringilla nunc dui eget nibh."*/}
      {/*    image={barista}*/}
      {/*    height={{ xs: "260px", md: "245px" }}*/}
      {/*    width={{ xs: "100%", md: "50%" }}*/}
      {/*    onClick={() => console.log("Banner 2 clicked")}*/}
      {/*  />*/}
      {/*</Box>*/}
    </Box>
  );
};

export default About;
